import React, {useEffect, useState} from "react";
import {Form, FormikProps} from "formik";
import Input from "../../Elements/Form/Input";
import InputFile from "../../Elements/Form/InputFile";
import Button from "../../Elements/Button";
import useQuery from "../../../hook/useQuery";
import httpClient from "../../../services/httpClient";
import {podcastsApi} from "../../../constans/apiUrls";
import Loading from "../../Elements/Loading/Loading";
import useToastNotify from "../../../hook/useToastNotify";
import {useHistory} from "react-router-dom";
import {IPodcastData} from "../../../contracts/data/podcast";


const InnerPodcastForm = (props: FormikProps<IPodcastData>) => {
    const queryParams = useQuery()
    const history = useHistory()
    const {toastNotify} = useToastNotify()
    const [loading, setLoading] = useState<boolean>(true)

    const handleFetchPrevData = async () => {
        await httpClient().get(`${podcastsApi.update}/${queryParams.get('id')}`)
            .then(response => {
                if (response.status === 200){
                    props.setValues(response?.data?.data)
                }
            })
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        if(props?.status?.formType === 'edit' && queryParams.get('id')){
            handleFetchPrevData()
        }else {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        if(props.status.hasOwnProperty('result')){
            toastNotify(props.status?.result?.status, props.status?.result?.message)
            if(props.status?.result?.status === 'success'){
                history.replace('/dashboard/podcasts/list')
            }
        }
    }, [props.status])

    return (
        <React.Fragment>
            {loading ? <Loading />:
                <Form>
                    <div className={"w-3/5"}>
                        <Input name={"title"} label={"عنوان پادکست"} placeholder={"عنوان..."} isRequired
                               meta={props.getFieldMeta('title')} defaultValue={props.values?.title}/>
                        <Input name={"slug"} label={"نامک پادکست"} placeholder={"نامک..."} isRequired
                               meta={props.getFieldMeta('slug')} defaultValue={props.values?.slug}/>
                        <Input name={"narrator"} label={"گوینده پادکست"} placeholder={"گوینده..."} isRequired
                               meta={props.getFieldMeta('narrator')} defaultValue={props.values?.narrator}/>
                        <Input name={"audio"} label={"لینک پادکست"} placeholder={"لینک..."} isRequired
                               meta={props.getFieldMeta('audio')} defaultValue={props.values?.audio}/>
                        <InputFile name={"image"} accept={".jpg,.jpeg,.png"} label={"عکس"}
                                   meta={props.getFieldMeta('image')} isImg handleUploadFile={props.setFieldValue}
                                   defaultValue={props.values?.image}
                        />
                    </div>
                    <div className={"text-left"}>
                        <Button title={props.status?.formType === 'create' ? "ثبت پادکست جدید" : "بروزرسانی پادکست"} isLoading={props.isSubmitting}/>
                    </div>
                </Form>}
        </React.Fragment>
    )
}

export default InnerPodcastForm